import Vue from 'vue'
import axios from 'axios'

let baseURL = ''
console.log(window.location)
if (location.origin.includes('test')) {
  baseURL = 'https://testnsrc.databeehub.cn/'
} else {
  baseURL = 'https://nsrc.databeehub.cn/'
}
console.log()

const service = axios.create({
  baseURL: process.env.NODE_ENV == 'development' ? '/' : baseURL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const result = response.data;
    // const resKey = Config.response
    // let res = response.data
    // if (resKey.outData) {
    //   res = res[resKey.outData]
    // }
    // let code = res[resKey.code]
    // let data = res[resKey.data]
    // let msg = res[resKey.msg]
    // return { msg, data, status: code == resKey.successVal, code, result: res }

    return result
  },
  (error) => {
    if (error.response.status == 401) {
      // window.location.href=getProjectName()+"vmbr/index.html";
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$http = service;

export default service


// WEBPACK FOOTER //
// ./src/utils/http.js